/**
 * Game loop central para jogos idle.
 * Gerencia ticks, delta time e calculo de progresso offline.
 */
export class GameLoop {
  private lastTime = 0;
  private tickRate: number;
  private onTick: (dt: number) => void;
  private running = false;
  private rafId = 0;

  constructor(tickRate: number, onTick: (dt: number) => void) {
    this.tickRate = tickRate;
    this.onTick = onTick;
  }

  start() {
    this.running = true;
    this.lastTime = performance.now();
    this.loop(this.lastTime);
  }

  stop() {
    this.running = false;
    cancelAnimationFrame(this.rafId);
  }

  private loop = (now: number) => {
    if (!this.running) return;
    const dt = (now - this.lastTime) / 1000;
    this.lastTime = now;

    // Cap delta to prevent spiral of death
    const cappedDt = Math.min(dt, 1 / this.tickRate);
    this.onTick(cappedDt);

    this.rafId = requestAnimationFrame(this.loop);
  };

  /**
   * Calcula progresso offline baseado no tempo que passou.
   * @param lastSaveTime timestamp do ultimo save
   * @param maxOfflineSeconds maximo de segundos offline (default 8h)
   * @returns segundos de progresso offline
   */
  static calculateOfflineProgress(lastSaveTime: number, maxOfflineSeconds = 28800): number {
    const now = Date.now();
    const elapsed = (now - lastSaveTime) / 1000;
    return Math.min(elapsed, maxOfflineSeconds);
  }
}
